import { defineStore } from 'pinia';
import { pinia } from './index';
import { FlipCoinConfigVO, getFlipCoinConfig } from '@/api/finance/game/config';

export const useGameConfig = defineStore('app-gameConfig', {
  state: () => ({
    isSetConfig: false,
    flipCoinConfig: {} as FlipCoinConfigVO
  }),

  getters: {
    getFlipCoinConfig(): FlipCoinConfigVO {
      return this.flipCoinConfig;
    },
  },

  actions: {
    reset(): void {
      this.isSetConfig = false;
    },
    async updateAllConfig(): Promise<void> {
      this.flipCoinConfig = await getFlipCoinConfig();
      // 其他游戏配置
      // ...
      this.isSetConfig = true;
    },
    async updateFlipCoinConfig(): Promise<void> {
      this.flipCoinConfig = await getFlipCoinConfig();
    },
  }
});

export const useGameConfigStore = () => {
  return useGameConfig(pinia);
};